export default "__VITE_ASSET__BULIQFXU__"